import { render, staticRenderFns } from "./CreateOrderDirectArticles.vue?vue&type=template&id=7cc55f82"
import script from "./CreateOrderDirectArticles.vue?vue&type=script&lang=js"
export * from "./CreateOrderDirectArticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports